import React from "react";
import SoldOutMenu from "../models/sold_out_menu_model";

interface Props {
    title: string;
    soldOutMap: Map<string, SoldOutMenu[]>
}

export default class SoldOutDashboardTableWidget extends React.Component<Props> {
    
    render(): React.ReactNode {
        return (
            <>
                <h1 className="font-bold text-2xl text-white m-1 p-1">
                    {this.props.title}
                </h1>
                <div className={`grid md:grid-cols-2 bg-gray-100`}>
                    {
                        [...this.props.soldOutMap.entries()]
                        .map(([outletName, menuData]) => menuData.length > 0 
                            ? (
                            <div key={outletName} className="border border-gray-700 border-r-2 border-l-0 border-b-1 text-start p-1 bg-gray-100 flex flex-wrap content-start">
                                <span className="font-semibold text-sm m-1">
                                    {outletName} :
                                </span>
                                {
                                    menuData.sort((a, b) => a.name.length - b.name.length)
                                    .map((data) => (
                                        <div className="m-[2px]" key={data.id}>
                                            <span
                                                className="p-1 m-0.5 rounded-lg text-xs"
                                                style={{
                                                    backgroundColor:
                                                        data.backgroundColor != "" ? data.backgroundColor : "#FCFBF3",
                                                    color: data.textColor != "" ? data.textColor : "#202020",
                                                }}
                                            >
                                                {data.name} [{data.soldOutDuration ?? ""}]
                                            </span>
                                        </div>
                                    ))
                                }
                            </div>)
                            : null
                        )
                    }
                </div>
            </>
        );
    }
}